// Utility functions for aggregating worked time in attendance
import {
  TimesheetAggregatedWorkedTimeFragment,
  TimesheetWorkedTimeBlockFragment,
  TimesheetWorkedTimeFragment,
} from 'generated/resources/graphql'

export interface AggregatedWorkedTimeBlocks {
  breaksMinutesRounded: number
  minutes: number
  multipliedMinutes: number
  paidAbsencesMinutes: number
  paidBreaksMinutes: number
  pendingMinutes: number
  toleranceMinutesRounded: number
  trackedMinutes: number
  regularMinutes: number
  effectiveWorkedMinutes: number
  workedTimeBlocks: TimesheetWorkedTimeBlockFragment[]
  extraTimeMinutes: number
}

class AttendanceWorkedTimeUtils {
  static aggregatedWorkedTimeBlocks(
    workedTimes: TimesheetWorkedTimeFragment[],
    aggregatedWorkedTime?: TimesheetAggregatedWorkedTimeFragment | null
  ): AggregatedWorkedTimeBlocks {
    const workedTimeBlocks = workedTimes.flatMap((wt) => wt.workedTimeBlocks || [])

    const paidBreaksMinutes =
      workedTimeBlocks.length > 0
        ? workedTimeBlocks.reduce(
            (sum, block) => sum + (block.workable ? 0 : block.minutes || 0),
            0
          )
        : aggregatedWorkedTime?.paidBreaksMinutes ?? 0

    return {
      breaksMinutesRounded: workedTimes.reduce(
        (sum, wt) => sum + (wt.breaksMinutesRounded || 0),
        0
      ),
      minutes: workedTimes.reduce((sum, wt) => sum + (wt.minutes || 0), 0),
      multipliedMinutes: workedTimes.reduce((sum, wt) => sum + (wt.multipliedMinutes || 0), 0),
      paidAbsencesMinutes: workedTimes.reduce((sum, wt) => sum + (wt.paidAbsencesMinutes || 0), 0),
      paidBreaksMinutes,
      pendingMinutes: workedTimes.reduce((sum, wt) => sum + (wt.pendingMinutes || 0), 0),
      toleranceMinutesRounded: workedTimes.reduce(
        (sum, wt) => sum + (wt.toleranceMinutesRounded || 0),
        0
      ),
      trackedMinutes: workedTimes.reduce((sum, wt) => sum + (wt.trackedMinutes || 0), 0),
      workedTimeBlocks,
      regularMinutes: workedTimes.reduce((sum, wt) => sum + (wt.regularMinutes || 0), 0),
      effectiveWorkedMinutes: workedTimes.reduce(
        (sum, wt) => sum + (wt.effectiveWorkedMinutes || 0),
        0
      ),
      extraTimeMinutes: workedTimes.reduce((sum, wt) => sum + (wt.extraTimeMinutes || 0), 0),
    }
  }
}

export default AttendanceWorkedTimeUtils
